import React from "react";
import css from "./Contact.module.css";

const Contact = () => {
	return (
		<section className={css.contact}>
			<h2>Contact</h2>
			<p>Contact page</p>
		</section>
	);
};

export default Contact;
